import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { playerComparisonFiltersSelector } from 'store/modules/statspro/player-comparison/selectors/filters-selector';
import { getTranslation } from 'common/react/utils/translations';
import { SelectMultiple } from 'common/react/components/select-multiple';
import { SvgIcon } from 'common/react/components/SvgIcon';
import { useGetTeamsQuery } from 'store/modules/api/afl-api';
import { useFavouriteTeam } from 'common/react/hooks/use-favourite-team';
import { playerComparisonActions } from 'common/store/modules/statspro/player-comparison';

export const PlayerSelectionTeamsFilters = ({
    addOnResetCallback,
    compseason
}) => {
    const dispatch = useDispatch();

    const filters = useSelector(playerComparisonFiltersSelector);
    const { data: teamsList } = useGetTeamsQuery(compseason, {
        skip: !compseason ? true : false
    });

    const favouriteTeam = useFavouriteTeam();

    const teams = useMemo(() => {
        if (!teamsList) {
            return null;
        }

        const sortedTeams = [...teamsList].sort((a, b) =>
            a.name.localeCompare(b.name)
        );

        return favouriteTeam
            ? PULSE.app.common.team.moveFavouriteTeamToFront(
                  sortedTeams,
                  favouriteTeam
              )
            : sortedTeams;
    }, [teamsList, favouriteTeam]);

    const updateFilterItem = (filterItem, value) => {
        dispatch(
            playerComparisonActions.setFilterItem({
                filterItem,
                value
            })
        );
    };

    return (
        <SelectMultiple
            items={teams}
            getInitialSelectedItems={() => {
                return teams.filter((t) =>
                    filters.teams.includes(t.providerId)
                );
            }}
            label={getTranslation('label.statsLeaders.filters.team')}
            icon="guernsey"
            itemToString={(team) => team.name}
            onSelectedItemsChange={(team) => {
                updateFilterItem(
                    'teams',
                    team.map((t) => t.providerId)
                );
            }}
            addOnResetCallback={addOnResetCallback}
            getItemText={(item) => item.name}
            getItemLabel={(item) => (
                <span
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'space-between',
                        lineHeight: 1,
                        width: '100%'
                    }}
                    className={`${
                        item.favouriteTeam
                            ? 'select-multiple__favourite-team'
                            : ''
                    }`}
                >
                    <span style={{ marginRight: '1rem' }}>{item.name}</span>
                    <SvgIcon
                        icon={`aflc-${PULSE.app.common.team.getTeamAbbr(
                            item.providerId
                        )}-flag`}
                        style={{ width: '3.1rem', maxHeight: '3rem' }}
                    />
                </span>
            )}
        />
    );
};

PlayerSelectionTeamsFilters.propTypes = {
    addOnResetCallback: PropTypes.func,
    compseason: PropTypes.string.isRequired
};
